// @ts-expect-error untyped dep
import UIIFrame from 'ui-addon-iframeable/host/UIIFrame';
import PortalIdParser from 'PortalIdParser';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useUIIFrameConnector } from 'crm-message-bus/useUIIFrameConnector';
import { useDispatch } from 'crm-cards-sdk/internal/perf/LocationStateContext';
import { Metrics } from './internal/Metrics';
import { useCardLocationContext } from 'crm-cards-sdk/internal/CardLocationContext';
import { getFullUrl } from 'hubspot-url-utils';
import { View } from 'foundations-components/components/View';
import { useCardContainerContext } from 'crm-cards-sdk/internal/CardContainerContext';
import { jsx as _jsx } from "react/jsx-runtime";
let iframedCardCount = 0;
function getIframedCardCount() {
  return iframedCardCount++;
}
function getShowLocalIframe() {
  try {
    return localStorage.getItem('CRM:SDK:show-local-iframe') === 'true';
  } catch (e) {
    return false;
  }
}
export default function IframedCrmCard({
  cardData,
  CardFormatter,
  ActionFormatter
}) {
  var _document$getElementB;
  const {
    location,
    loggingTag,
    additionalLocationData,
    features,
    propertySource,
    viewId
  } = useCardLocationContext();
  const {
    isSingleCardRenderer
  } = useCardContainerContext();
  const iframedCardIndex = useRef(getIframedCardCount());
  const {
    onUIIFrameReady,
    onUIIFrameMessage
  } = useUIIFrameConnector();
  const domNodeId = `${location}-${iframedCardIndex.current}-iframed-card-${cardData.definition.cardId}`;
  const [width, setWidth] = useState(((_document$getElementB = document.getElementById(domNodeId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.clientWidth) || 600);
  const [height, setHeight] = useState(300);
  const resizeObserver = useRef();
  const dispatch = useDispatch();
  const hostContext = useRef();
  const handleOnReady = useCallback(hostCtx => {
    hostContext.current = hostCtx;
    onUIIFrameReady(hostCtx);
  }, [hostContext, onUIIFrameReady]);
  const handleReceiveMessage = useCallback(message => {
    if (message.payload.type === 'CARD_RESIZED' && height !== message.payload.height) {
      setHeight(message.payload.height);
    } else if (message.payload.type === 'CARD_LOADING_FINISHED') {
      dispatch(message.payload);
    } else {
      onUIIFrameMessage(message);
    }
  }, [setHeight, height, onUIIFrameMessage, dispatch]);
  useEffect(() => {
    Metrics.counter('iframe-rendered', Object.assign({
      card_type: cardData.definition.cardType,
      location
    }, loggingTag ? {
      logging_tag: loggingTag
    } : {})).increment();
  }, [cardData.definition.cardType, location, loggingTag]);
  useEffect(() => {
    const cardWrapper = document.getElementById(domNodeId);
    if (!resizeObserver.current && cardWrapper) {
      resizeObserver.current = new ResizeObserver(entries => {
        const e = entries[0]; // should be only one

        // resize based on width only
        if (width !== e.contentRect.width) {
          setWidth(e.contentRect.width);
        }
      });
      resizeObserver.current.observe(cardWrapper);
    }
    return () => {
      var _resizeObserver$curre;
      (_resizeObserver$curre = resizeObserver.current) === null || _resizeObserver$curre === void 0 || _resizeObserver$curre.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domNodeId]);
  const cardFormatterKey = (CardFormatter === null || CardFormatter === void 0 ? void 0 : CardFormatter.iframeLookupKey) || 'TileCardFormatter';
  const passthruProps = useMemo(() => {
    return {
      cardData,
      CardFormatterKey: cardFormatterKey,
      ActionFormatterKey: ActionFormatter === null || ActionFormatter === void 0 ? void 0 : ActionFormatter.iframeLookupKey,
      locationContext: {
        additionalLocationData,
        features,
        propertySource,
        viewId
      }
    };
  }, [ActionFormatter, additionalLocationData, cardData, cardFormatterKey, features, propertySource, viewId]);
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "crm-card-iframe",
    id: domNodeId,
    inlineSize: "100%",
    marginBlockEnd: !isSingleCardRenderer && cardFormatterKey === 'TileCardFormatter' ? '400' : undefined,
    children: /*#__PURE__*/_jsx(UIIFrame, {
      name: "crm-card-iframe",
      width: width,
      height: height,
      src: `${getShowLocalIframe() ? getFullUrl('local') : getFullUrl('app')}/crm-card-iframe/${PortalIdParser.get()}`,
      onReady: handleOnReady,
      onMessage: handleReceiveMessage,
      embeddedPassthruProps: passthruProps
    })
  });
}